<img *ngIf="preview.image" src="{{ preview.image }}" class="preview-image" (click)="openDetails()">
<p class="preview-text" (click)="openDetails()">{{ preview.text }}</p>
